import { createLabeledMessages } from '../../../messageUtils';
const print = {
    loading: 'Loading document, please wait.',
    loaded: 'Document was loaded, you can close this tab.'
};
export default Object.assign({}, print, createLabeledMessages(print));
